export default __webpack_public_path__ + "static/media/039-gateway arch.3587ffe9.svg";